export const CATEGORY_FOOD = [
  {
    title: "ВСЁ",
    // type:'all',
  },
  {
    title: "Lazy Snark",
    type: "lazy_snark",
  },
  {
    title: "Izy",
    type: "izy",
  },
  {
    title: "Кофе",
    type: "coffee",
  },
];
